export function hexColorChannels(color: string | null): string | null {
  if (!color || !/^#[0-9a-f]{6}$/i.test(color)) return null;
  return [1, 3, 5]
    .map((index) => Number.parseInt(color.slice(index, index + 2), 16))
    .join(", ");
}
